import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import cnames from 'classnames'
import { routesHandler } from 'Checkout/Routes/routesHandler'
import CollapseWrapper from 'Shared/Collapse/CollapseWrapper'
import ReservationContent from 'Checkout/Components/Shared/CartSummary/ReservationContent'

const Reservation = ({ isCollapseOpen, reservation, wrapperClasses }) => {
  const { pathname } = useLocation()
  const { autoAssign, inProgress, pricing, rate, site } = reservation
  const { items } = pricing || {}
  const classnameWrapper = cnames('reservation', wrapperClasses, { 'not-loading': !inProgress })
  const siteAssigned = (autoAssign === 'auto' || !site) ? rate?.name : site?.name
  const collapseTitle = siteAssigned || 'Loading...'
  const isPaymentStep = pathname === routesHandler.payment.path
  const titleHelper = cnames({ 'in Progress': inProgress })
  const pricingTier = items?.find(item => item.itemableType === 'pricing_tier')

  return (
    <CollapseWrapper className={classnameWrapper} isOpenByDefault={isCollapseOpen || inProgress}>
      <CollapseWrapper.Header keepChildren title={collapseTitle} anchorClassWrapper="not-loading"
                              titleHelper={titleHelper} withRenderProps>
        {({ handleState, isOpen }) => {
          useEffect(() => {
            if (isPaymentStep) handleState()
          }, [isPaymentStep])

          return (
            <span className="text-start">
              {isOpen ? pricingTier?.base?.display : pricing?.subtotal?.display}
            </span>
          )
        }}
      </CollapseWrapper.Header>

      <CollapseWrapper.Content className="pt-1">
        <ReservationContent reservation={reservation} />
      </CollapseWrapper.Content>
    </CollapseWrapper>
  )
}

export default Reservation
